import File from 'relements/build/esm/input/file';
import Checkbox from 'relements/build/esm/input/checkbox';
import Text from 'relements/build/esm/input/text';
import Chips from 'relements/build/esm/input/chips';
import Radio from 'relements/build/esm/input/radio';

const COMMON_CONFIG = {
  title: 'Common Configurations (JS, SDK, Android)',
  inputs: [
    {
      label: 'Business Icon',
      key: 'businessIcon',
      component: File,
      props: {
        placeholder: 'Upload Business Icon',
        prefixClassName: 'business-icon-logo',
        dimensions: '256px X 256px',
        type: 'image',
        maxFileSize: 1,
        tooltip:
          'This icon will be visible on the header of the JS SDK Chat UI and on the inbox screen of Android, iOS',
      },
    },
    {
      label: 'Business Active & Visible',
      key: 'businessActive',
      className: 'sdk-configurations-checkbox-item',
      component: Checkbox.Item,
      props: {
        tooltip: 'A User can view and chat with the business',
      },
    },
    {
      label: 'Show Haptik Branding',
      key: 'showHaptikBranding',
      className: 'sdk-configurations-checkbox-item',
      component: Checkbox.Item,
      props: {
        tooltip: 'Branding of Haptik will be shown above the typing box',
      },
    },
    {
      label: 'Enforce GDPR',
      key: 'gdpr',
      component: Radio,
      props: {
        options: [{ title: 'Yes', value: true }, { title: 'No', value: false }],
      },
    },
    {
      label: 'Enable Per Message User Feedback',
      key: 'showUserFeedback',
      component: Radio,
      props: {
        options: [{ title: 'Yes', value: true }, { title: 'No', value: false }],
      },
    },
    {
      label: 'Positive Question for per message User Feedback',
      key: 'userFeedbackQuestionPositive',
      component: Text,
      props: {
        placeholder: 'Positive feedback question asked in detailed feedback',
        tooltip:
          'This text appears when user clicks comment icon after adding a positive feedback.',
      },
    },
    {
      label: 'Negative Question for per message User Feedback',
      key: 'userFeedbackQuestionNegative',
      component: Text,
      props: {
        placeholder: 'Negative feedback question asked in detailed feedback',
        tooltip:
          'This text appears when user clicks comment icon after adding a positive feedback.',
      },
    },
    {
      label: 'Positive Tags for per message User Feedback',
      key: 'userFeedbackTagsPositive',
      component: Chips,
      props: (value, onChange) => ({
        onChange: val => {
          onChange(val.map(tag => ({ value: tag })));
        },
      }),
    },
    {
      label: 'Negative Tags for per message User Feedback',
      key: 'userFeedbackTagsNegative',
      component: Chips,
      props: (value, onChange) => ({
        onChange: val => {
          onChange(val.map(tag => ({ value: tag })));
        },
      }),
    },
  ],
};

export default COMMON_CONFIG;
